export type TaskAudience = 'supervisors' | 'mechanics' | 'anyone';

export type TaskAudienceFilter = TaskAudience | 'all';

export const TASK_AUDIENCE_OPTIONS: ReadonlyArray<{
  value: TaskAudience;
  labelKey: string;
}> = [
  { value: 'anyone', labelKey: 'tasks.audienceAnyone' },
  { value: 'supervisors', labelKey: 'tasks.audienceSupervisors' },
  { value: 'mechanics', labelKey: 'tasks.audienceMechanics' },
];

export const TASK_AUDIENCE_FILTER_OPTIONS: ReadonlyArray<{
  value: TaskAudienceFilter;
  labelKey: string;
}> = [
  { value: 'all', labelKey: 'tasks.audienceAll' },
  { value: 'supervisors', labelKey: 'tasks.audienceSupervisors' },
  { value: 'mechanics', labelKey: 'tasks.audienceMechanics' },
];

export function audienceLabelKey(audience: TaskAudience): string {
  return (
    TASK_AUDIENCE_OPTIONS.find((option) => option.value === audience)?.labelKey
    ?? 'tasks.audienceAnyone'
  );
}

/** Mechanics default to their audience; everyone else sees the unfiltered list. */
export function defaultAudienceListFilter(
  role: string | undefined,
): TaskAudience | undefined {
  return role === 'mechanic' ? 'mechanics' : undefined;
}
